import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import searchAgentView from 'views/agent/agent-retraction/search'; // Importing search agent view component
import transfersDetail from 'views/agent/agent-retraction/PagoPremio'; // Importing transfers detail component
import transfers1 from 'views/agent/agent-retraction/transfers1'; // Importing first transfers component
import transfers from 'views/agent/agent-retraction/transfers'; // Importing transfers component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the Agents Retraction View.
 * @extends JetView
 */
export default class AgentsRetractionView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        const left = {
            // Left side configuration
            Width: 250,
            responsiveCell: false,
            rows: [
                {
                    view: 'toolbar', // Toolbar component
                    css: theme, // Applying theme CSS
                    elements: [
                        {
                            width: 30,
                            css: 'back-button', // CSS class for back button
                            view: 'button', // Button component
                            type: 'icon', // Icon button type
                            icon: 'wxi-angle-left', // Icon for back button
                            id: 'back-button', // Unique ID for back button
                            align: 'center', // Center alignment
                            click: () => {
                                // Click event handler for back button
                                webix.html.removeCss(
                                    // Remove CSS class from button1
                                    $$('button1').$view,
                                    'green',
                                );
                                webix.html.removeCss(
                                    // Remove CSS class from button2
                                    $$('button2').$view,
                                    'green',
                                );
                                $$('formPagoPremio1').hide(); // Hide formPagoPremio1
                                $$('formPagoPremio').hide(); // Hide formPagoPremio
                                $$('formPago').hide(); // Hide formPago
                                $$('back-button').hide(); // Hide back button
                                $$('consult-section').show(); // Show consult section
                            },
                        },
                        {
                            view: 'label', // Label component
                            align: 'center', // Center alignment
                            label: _('Retracción a Usuario'), // Label text with localization
                        },
                        {
                            type: 'wide',
                            css: 'close-bottom', // CSS class for close button
                            cols: [
                                {
                                    view: 'icon', // Icon component
                                    icon: 'wxi-close', // Close icon
                                    bottom: 20, // Bottom margin
                                    right: 35, // Right margin
                                    width: 30, // Icon width
                                    height: 30, // Icon height
                                    click: () => this.show('/top/dashboard'), // Click event to navigate to dashboard
                                },
                            ],
                        },
                    ],
                },
                searchAgentView, // Including search agent view
                transfersDetail, // Including transfers detail view
            ],
        };

        const right = {
            // Right side configuration
            type: 'wide',
            rows: [transfers1, transfers], // Including transfers components
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode

        return {
            // Return the main configuration object
            id: 'a5', // Unique ID for the form
            type: 'wide',
            view: 'form', // Form view
            scroll: 'y', // Enable vertical scrolling
            css: 'my-background', // Background CSS class
            height: 0, // Height set to 0 for dynamic sizing
            rows: [left, right], // Combine left and right configurations
        };
    }

    /**
     * Initializes the view components.
     */
    init() {
        $$('back-button').hide(); // Initially hide the back button
    }
}

// FILE DOCUMENTED
